import cx from 'classnames'
import {intersection, uniq} from 'lodash'
import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {useMemo} from 'react'
import {Ventrata} from 'types'
import {SLT} from './SLT'

const KNOWN_WIDGETS: Record<string, (props: any) => JSX.Element> = {
  SLT,
}

type Props = {
  order: Ventrata.Order | null
  className?: string
}

export const ConfirmationPagePromotion = ({order, className}: Props) => {
  const variations = EnvironmentProvider.useVariations()

  const widgetsData = useMemo(() => {
    const widgetsData = []
    const usedWidgetCodes = Object.keys(variations?.conditions ?? {}).filter((code) =>
      code.startsWith('confirmationPagePromotion')
    )
    const usedProductIds = uniq(order?.bookings.map((booking) => booking.product.id))

    for (const widgetCode of usedWidgetCodes) {
      const widgetId = widgetCode.split(':')[1]

      if (!widgetId) {
        console.warn(`Invalid widget code, code '${widgetCode}'`)
        continue
      }

      const widget = KNOWN_WIDGETS[widgetId]

      if (!widget) {
        console.warn(`Unknown widget, code '${widgetCode}'`)
        continue
      }

      const conditionConfig = variations?.conditions[widgetCode]

      if (!Array.isArray(conditionConfig)) {
        console.warn(`Invalid widget condition config, code '${widgetCode}'`)
        continue
      }

      if (intersection(conditionConfig, usedProductIds).length === 0) {
        continue
      }

      const widgetConfig = variations?.widgets[widgetCode]

      if (!widgetConfig) {
        console.warn(`Unknown widget config, code '${widgetCode}'`)
        continue
      }

      widgetsData.push({
        Component: widget,
        config: widgetConfig,
        code: widgetCode,
      })
    }

    return widgetsData
  }, [order, variations])

  if (!order || !variations) {
    return null
  }

  return (
    <div className={cx('flex flex-col gap-4 w-full d:w-[568px]', className)}>
      {widgetsData.map(({Component, config, code}) => {
        return <Component key={code} config={config} order={order} />
      })}
    </div>
  )
}
